import { jsx as _jsx } from "react/jsx-runtime";
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { ToggleBaseButtonView } from './ToggleBaseButtonView';
export const ToggleButtonView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.toggleButton,
    style(style, mediaQuery, window, props) {
        return {
            container: {
                backgroundColor: 'rgba(255, 255, 255, 1)',
                borderColor: 'rgba(57, 78, 102, 1)',
                borderWidth: 1
            },
            text: {
                color: props.value
                    ? 'rgba(255, 255, 255, 1)'
                    : 'rgba(57, 78, 102, 1)'
            },
            hover: {
                backgroundColor: 'rgba(57, 78, 102, 0.5)'
            },
            pressed: {
                backgroundColor: 'rgba(57, 78, 102, 1)'
            },
            inactive: {
                borderColor: 'rgba(57, 78, 102, 0.3)'
            },
            disabled: {
                opacity: 0.4
            }
        };
    }
})((props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const btnStyles = Object.assign(Object.assign(Object.assign({}, (_a = props.style) === null || _a === void 0 ? void 0 : _a.container), { backgroundColor: (_c = (_b = props.style) === null || _b === void 0 ? void 0 : _b.container) === null || _c === void 0 ? void 0 : _c.backgroundColor, borderColor: props.defaultBackground || ((_e = (_d = props.style) === null || _d === void 0 ? void 0 : _d.container) === null || _e === void 0 ? void 0 : _e.borderColor) }), props.containerStyle);
    return _jsx(ToggleBaseButtonView, Object.assign({}, props, { style: undefined, containerStyle: btnStyles, textStyle: [(_f = props.style) === null || _f === void 0 ? void 0 : _f.text, props.textStyle], disabled: props.disabled || props.inactive, defaultBackground: (_h = (_g = props.style) === null || _g === void 0 ? void 0 : _g.container) === null || _h === void 0 ? void 0 : _h.backgroundColor, hoverBackground: (_k = (_j = props.style) === null || _j === void 0 ? void 0 : _j.hover) === null || _k === void 0 ? void 0 : _k.backgroundColor, pressBackground: (_m = (_l = props.style) === null || _l === void 0 ? void 0 : _l.pressed) === null || _m === void 0 ? void 0 : _m.backgroundColor, inactiveBackground: (_p = (_o = props.style) === null || _o === void 0 ? void 0 : _o.inactive) === null || _p === void 0 ? void 0 : _p.backgroundColor, disableBackground: (_r = (_q = props.style) === null || _q === void 0 ? void 0 : _q.disabled) === null || _r === void 0 ? void 0 : _r.backgroundColor }));
});
